import { reactive } from 'vue';

export const liderancasStore = reactive({
    isLoading: false,
    isReady: false,
    liderancas: null,
    liderancasIds: [],
    isLider: false,

    async carregarLiderancas() {
        if (this.isReady || this.isLoading) {
            return;
        }

        this.isLoading = true;
        this.isReady = false;

        try {
            const { departamentoService } = await import('../service/departamento-service');
            const liderancasData = await departamentoService.getLiderancas();
            
            this.liderancas = liderancasData;
            this.liderancasIds = Array.isArray(liderancasData) ? liderancasData.map(lideranca => lideranca.id) : [];
            this.isLider = Array.isArray(liderancasData) && liderancasData.length > 0;
            this.isReady = true;
        } catch (error) {
            console.error("Erro ao carregar lideranças:", error);
            this.liderancas = null;
            this.liderancasIds = [];
            this.isLider = false;
            this.isReady = false;
        } finally {
            this.isLoading = false;
        }
    }
})